import 'zone.js';
import './src/shared-angular/polyfills.js';
import './src/polyfills.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
